import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
`;

const IconLum = styled.img`
  height: 96px;
  width: 96px;
  left: 0px;
  top: 0px;
  border-radius: 8px;
`;

const Text = styled.p`
  margin-top: 16px;
  color: var(--text-text02);
`;

const SuggestionContainer = styled.div`
  max-width: 395px;
  min-width: 325px;
  margin-top: 24px;
  background: var(--primary-disable-background);
  padding: 8px 12px;
  border-radius: 4px;

  font-weight: 700;
  font-size: 14px;
  color: var(--text-text02);

  ul {
    font-weight: 400;
    list-style-type: disc;
    list-style-position: inside;

    li {
      margin-left: 9px;
      span {
        position: relative;
        left: -7px;
      }
    }
  }
`;

export { IconLum, Container, Text, SuggestionContainer };
